import React, { useEffect } from 'react';

import { motion, transform, useMotionValue } from 'framer-motion';

import './OutputBubble.scss';

export interface OutputBubbleProps {
    value: string | number;
    progress?: number;
    contributors?: string[];
}

const progressBreakpoints = [0, 10, 30, 60, 80, 100];
// TODO: We need to be able to share these tokens across languages:
// $yat-color-white, $yat-color-green-3,, $yat-color-forest-2
// $yat-color-citrus-1, $yat-color-orange-2, $yat-color-red-1
const colorBreakpoints = ['#fff', '#a1d15e', '#009e54', '#f7fc14', '#f67916', '#e60256'];

export function OutputBubble({ value, progress = 0, contributors = [] }: OutputBubbleProps) {
    const progressValue = useMotionValue(progress);
    const color = useMotionValue(colorBreakpoints[0]);

    useEffect(() => {
        progressValue.set(progress);
        const newColor = transform(progressValue.get(), progressBreakpoints, colorBreakpoints);
        color.set(newColor);
    }, [color, progressValue, progress]);

    const targetIds = contributors.length ? contributors.join(' ') : undefined;

    return (
        <motion.output htmlFor={targetIds} className="OutputBubble" style={{ color }}>
            <span className="OutputBubble-Text">{value}</span>
        </motion.output>
    );
}
